// extracted by mini-css-extract-plugin
export default {"no_data":"charts_no_data__xwLwi"};